import { render, staticRenderFns } from "./processAccidentAppr.vue?vue&type=template&id=6d2673d8"
import script from "./processAccidentAppr.vue?vue&type=script&lang=js"
export * from "./processAccidentAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d2673d8')) {
      api.createRecord('6d2673d8', component.options)
    } else {
      api.reload('6d2673d8', component.options)
    }
    module.hot.accept("./processAccidentAppr.vue?vue&type=template&id=6d2673d8", function () {
      api.rerender('6d2673d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sop/iim/processAccidentAppr.vue"
export default component.exports